/** Returns true when the current route matches a main-menu section href. */
export function isMainMenuPathActive(pathname: string, href: string): boolean {
  if (href === "/") return pathname === "/";
  return pathname === href || pathname.startsWith(`${href}/`);
}

const MAIN_MENU_ITEM_INACTIVE =
  "main-menu-item transition-colors text-white hover:text-[#171717] dark:text-white/70 dark:hover:text-white";

const MAIN_MENU_ITEM_ACTIVE =
  "main-menu-item main-menu-item--active transition-colors text-[#171717] hover:text-[#171717] dark:text-white dark:hover:text-white";

/** Top-level main menu link / trigger classes with optional active (current page) state. */
export function mainMenuItemClass(isActive: boolean): string {
  return isActive ? MAIN_MENU_ITEM_ACTIVE : MAIN_MENU_ITEM_INACTIVE;
}

export const MAIN_MENU_TRIGGER_LAYOUT =
  "flex items-center gap-1 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 rounded dark:focus:ring-white/40 dark:focus:ring-offset-[#06080f]";
